/* global CookieScript */
import $ from 'jquery';
import engine from 'store/src/store-engine';
import storage from 'store/storages/cookieStorage';
import expirePlugin from 'store/plugins/expire';

function initNoticePopup(el) {
    const $el = $(el);

    // Activate cookie storage and expire plugin on init so sessions that are expired are removed
    const store = engine.createStore([storage], [expirePlugin]);
    const cookieValue = el.getAttribute('data-cookie-value');

    const isClosed = store.get('popup-notice');
    if (isClosed === cookieValue) {
        $el.slideUp('fast');
    }

    $el.find('.js-notice-close').click(() => {
        // Start by collecting Cookie script categories to check if user has allowed saving of funtional cookies
        if(window.CookieScript && CookieScript.instance) {
            const state = CookieScript.instance.currentState();
            const isAccepted = state && state.categories && state.categories.includes('functionality');
            if(isAccepted) {
                $el.slideUp('fast');
                const expire = 365 * 24 * 60 * 60 * 1000; // 365 days
                store.set('popup-notice', cookieValue, new Date().getTime() + expire);
            }
        }
    });
}

export default initNoticePopup;
